import React from 'react'
import PropTypes from 'prop-types'
import Svg from '../Components/shared/Svg'

const ContactBubbleSvg = ({ className, photo }) => (
  <Svg
    className={className}
    viewBox='0 0 79 65'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
  >
    <circle cx='52.5' cy='37.5' r='26.5' fill='#EB4F92' />
    <circle opacity='0.5' cx='38' cy='14' r='14' fill='#EB4F92' />
    <mask
      id='contact-bubble-ilustration-mask'
      style={{ maskType: 'alpha' }}
      maskUnits='userSpaceOnUse'
      x='0'
      y='5'
      width='60'
      height='60'
    >
      <path
        d='M59 35C59 51.0163 46.0163 64 30 64C13.9837 64 1 51.0163 1 35C1 18.9837 13.9837 6 30 6C46.0163 6 59 18.9837 59 35Z'
        fill='white'
        stroke='white'
        strokeWidth='2'
      />
    </mask>
    <g mask='url(#contact-bubble-ilustration-mask)'>
      <rect x='-2.5' y='5' width='65' height='65' fill='white' />
      <image id='image0_1441_45085' width='65' height='65' xlinkHref={photo} />
    </g>
    <path
      d='M59 35C59 51.0163 46.0163 64 30 64C13.9837 64 1 51.0163 1 35C1 18.9837 13.9837 6 30 6C46.0163 6 59 18.9837 59 35Z'
      stroke='white'
      strokeWidth='2'
    />
  </Svg>
)

ContactBubbleSvg.propTypes = {
  className: PropTypes.string,
  photo: PropTypes.string.isRequired,
}

export default ContactBubbleSvg
